<div class="imageDialog">
  <mat-toolbar color="primary">
    <div fxFlex></div>
    <button mat-icon-button (click)="dialogRef.close()" matTooltip="انصراف" matTooltipPosition="above"><mat-icon>close</mat-icon></button>
  </mat-toolbar>
  <div class="image">
    <img *ngIf="picture" src="data:image/JPEG;base64,{{picture}}">
    <img *ngIf="pictureAddress" src="{{pictureAddress}}">
  </div>
</div>
